export class AbstractEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    if (data instanceof AbstractEntity) {
      data = data._data
    }
    this._data = data || {}
  }
  get uuid() {
    return this._data.uuid
  }
  set uuid(uuid) {
    this._data.uuid = uuid
  }
  get createdBy() {
    return this._data.createdBy
  }
  set createdBy(createdBy) {
    this._data.createdBy = createdBy
  }
  get dateCreated() {
    return this._data.dateCreated
  }
  set dateCreated(dateCreated) {
    this._data.dateCreated = dateCreated
  }
  get modifiedBy() {
    return this._data.modifiedBy
  }
  set modifiedBy(modifiedBy) {
    this._data.modifiedBy = modifiedBy || 0
  }
  get dateModified() {
    return this._data.dateModified
  }
  set dateModified(dateModified) {
    this._data.dateModified = dateModified
  }
  get version() {
    return this._data.version
  }
  set version(version) {
    if (version !== 0) {
      version = version || 1
    }
    this._data.version = version
  }
  getData() {
    return this._data
  }
  /**
   * 获取所有属性名称
   */
  getPropertyNames() {
    let currentInstance = this
    const propertyNames = []
    // eslint-disable-next-line no-constant-condition
    while (true) {
      const currentPropertyNames = Object.getOwnPropertyNames(Reflect.getPrototypeOf(currentInstance)).filter(p => typeof currentInstance[p] !== 'function')
      const currentConstructor = Reflect.getPrototypeOf(currentInstance).constructor
      propertyNames.push(...currentPropertyNames)
      if (currentConstructor.name === AbstractEntity.name) break
      currentInstance = new (Reflect.getPrototypeOf(currentConstructor))(this._data)
    }
    return [...new Set(propertyNames)]
  }
  /**
   * 填充默认值
   */
  fillDefaultValue() {
    for (const name of this.getPropertyNames()) {
      if (typeof this[name] === 'undefined') {
        this[name] = ''
      }
    }
    return this
  }
  /**
   * 所有属性重置为默认值
   */
  reset() {
    for (const name of this.getPropertyNames()) {
      this[name] = ''
    }
    return this
  }
}
